import { useContext } from 'react';

import cn from 'classnames';

import { ContentContext } from 'context/ContentContext';

import { Rating } from 'ui/atoms/Rating/Rating';
import { OfferBlock } from 'ui/atoms/OfferBlock/OfferBlock';
import { Button } from 'ui/atoms/Button/Button';
import { Image } from 'ui/atoms/Image';

import styles from './AwardsBlock.module.scss';

const baseClass = 'awards-block';

const badges = ['badge-1', 'badge-2', 'badge-3', 'badge-4'];

type Props = {
  title: string;
  description: string;
  className?: string;
};

export const AwardsBlock = ({ title, description, className }: Props) => {
  const { secondaryNavigation, pageVars } = useContext(ContentContext);

  return (
    <section className={cn(styles[`${baseClass}-wrapper`], className)}>
      <div className={styles[`${baseClass}-container`]}>
        <OfferBlock
          title={title}
          description={description}
          kicker={
            <div className={styles[`${baseClass}-rating`]}>
              <Rating rating={4.5} title="4,5 out of 5 stars" />

              <p>
                <b>4,5</b> out of <b>5</b> stars
              </p>
            </div>
          }
          tools={
            <div className={styles[`${baseClass}-buttons`]}>
              <Button size="xl" type="dark" className={styles[`${baseClass}-button`]}>
                Get Started Now
              </Button>

              <Button
                size="xl"
                type="dark-outline"
                route={secondaryNavigation.book_demo.slug}
                className={styles[`${baseClass}-button`]}
              >
                {pageVars.common.book_demo_button}
              </Button>
            </div>
          }
        />

        <div className={styles[`${baseClass}-badges`]}>
          <div className={styles[`${baseClass}-badges-inner`]}>
            {badges.map((badge, idx) => (
              <Image key={idx} width={195} height={244} src={`img/badges/${badge}.png`} alt="Bage" />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
